<template>
  <el-scrollbar :native="false" style="height: 100%;width: 100%;">
    <el-main>
      <div class="screen-form my-[30px]">
        <div class="screen-form-item">
          <el-input
              v-model="inputKeyword"
              placeholder="关键词"
              prefix-icon="el-icon-search"
              style="width: 300px"
              @keyup.enter.native="searchTags">
          </el-input>
          <el-select v-model="selectSearch" placeholder="请选择"
                     style="width: 100px;vertical-align: middle;margin-left: 5px;">
            <el-option label="名称" value="1"></el-option>
            <el-option label="编码" value="2"></el-option>
          </el-select>
          <el-button style="vertical-align: middle;margin-left: 5px;" type="primary" @click="searchTags">搜索
          </el-button>
        </div>
      </div>
      <div class="screen-form table-operation">
        <el-button icon="el-icon-delete" plain type="danger" @click="batchDeletion">批量删除</el-button>
        <el-button icon="el-icon-circle-plus-outline" plain type="primary" @click="addNewTag">添加</el-button>
      </div>
      <el-table
          ref="multipleTable"
          :data="tagsList"
          style="width: 100%"
          tooltip-effect="dark"
          @cell-dblclick="cellEdit"
          @selection-change="handleSelectionChange">
        <el-table-column type="selection">
        </el-table-column>
        <el-table-column
            v-for="(item,index) in tenderingListTitle"
            :key="index"
            :align="item.propertyName==='code'||item.propertyName==='generalTerm'?'left':'center'"
            :header-align="item.propertyName==='code'?'left':'center'"
            :label="item.name"
            :prop="item.propertyName"
            :show-overflow-tooltip="item.propertyName==='generalTerm'?true:false"
            :width="item.propertyName==='code'?'100':''"
        >
          <template slot-scope="scope">
            <el-input
                v-if="item.propertyName!=='code'&&item.propertyName!=='generalTerm'&&scope.row[item.propertyName].edit"
                :ref="item.propertyName"
                v-model="scope.row[item.propertyName].value"
                style="width: 100%"
                @blur="saveEditItem(scope.row,item.propertyName)"
                @keyup.enter.native="saveEditItem(scope.row,item.propertyName)">
            </el-input>
            <span v-else>{{ scope.row[item.propertyName].value }}</span>
          </template>
        </el-table-column>
        <!--<el-table-column
                fixed="right"
                width="150"
                align="center"
                label="操作">
            <template slot-scope="scope">
                &lt;!&ndash;                    <router-link :to="{name:'backEditTenderingMessage'}" target="_blank">&ndash;&gt;
                <el-button
                        size="mini"
                        type="primary"
                        plain
                >
                    保存
                </el-button>
                <el-button
                        size="mini"
                        type="danger"
                        plain
                        @click="handleDelete(scope.$index, scope.row)"
                >
                    删除
                </el-button>
            </template>
        </el-table-column>-->
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
            :current-page="currentPage"
            :page-size="listPageSize"
            :page-sizes="[5, 10, 15, 20, 25, 30,50,100]"
            :total="listPageTotal"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-main>
    <el-dialog
        :before-close="closeAddTag"
        :visible.sync="dialogAddVisible"
        title="添加品目"
        width="50%">
      <el-form :model="addTagForm">
        <el-form-item label="编码" label-width="100px">
          <el-input v-model="addTagForm.code" autocomplete="off" style="width: 188px;"></el-input>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow>=1" label="一级标签" label-width="100px">
          <el-select
              v-model="addTagForm.level_1"
              allow-create
              default-first-option
              filterable
              placeholder="请选择或添加"
              @change="addTagChange($event,1)"
          >
            <el-option v-for="item in level_1"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow>=2" label="二级标签" label-width="100px">
          <el-select
              v-model="addTagForm.level_2"
              allow-create
              default-first-option
              filterable
              placeholder="请选择或添加"
              @change="addTagChange($event,2)"
          >
            <el-option v-for="item in level_2"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow>=3" label="三级标签" label-width="100px">
          <el-select
              v-model="addTagForm.level_3"
              allow-create
              default-first-option
              filterable
              placeholder="请选择或添加"
              @change="addTagChange($event,3)"
          >
            <el-option v-for="item in level_3"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow>=4" label="四级标签" label-width="100px">
          <el-select
              v-model="addTagForm.level_4"
              allow-create
              default-first-option
              filterable
              placeholder="请选择或添加"
              @change="addTagChange($event,4)"
          >
            <el-option v-for="item in level_4"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow>=5" label="五级标签" label-width="100px">
          <el-select
              v-model="addTagForm.level_5"
              allow-create
              default-first-option
              filterable
              placeholder="请选择或添加"
              @change="addTagChange($event,5)"
          >
            <el-option v-for="item in level_5"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="addTagForm.levelSelectShow>=6" label="六级标签" label-width="100px">
          <!--<el-input
                  style="vertical-align: middle;width: 188px;"
                  placeholder="请输入标签"
                  v-model="addTagForm.level_6">
          </el-input>-->
          <el-select
              v-model="addTagForm.level_6"
              allow-create
              default-first-option
              filterable
              placeholder="请选择或添加"
              @change="addTagChange($event,6)"
          >
            <el-option v-for="item in level_6"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="近义词" label-width="100px">
            <div class="tags-control">
                <el-tag
                        style="margin-left: 5px;"
                        :key="tag"
                        v-for="tag in optionsAddGeneralTerm.dynamicTags"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)">
                    {{tag}}
                </el-tag>
                <el-input
                        style="margin-left: 5px;"
                        class="input-new-tag"
                        v-if="optionsAddGeneralTerm.inputVisible"
                        v-model="optionsAddGeneralTerm.inputValue"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else
                           type="success"
                           plain
                           class="button-new-tag"
                           size="small"
                           style="margin-left: 5px;"
                           @click="showInput">
                    + 添加
                </el-button>
            </div>
        </el-form-item>-->
      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAddTag">保 存</el-button>
            </span>
    </el-dialog>
    <div v-show="maskShow" class="mask-layer">
      <div class="content">
        <div class="tags-control">
          <el-tag
              v-for="tag in optionsAddGeneralTerm.dynamicTags"
              :key="tag"
              :disable-transitions="false"
              closable
              @close="handleClose(tag)">
            {{ tag }}
          </el-tag>
          <el-input
              v-if="optionsAddGeneralTerm.inputVisible"
              ref="saveTagInput"
              v-model="optionsAddGeneralTerm.inputValue"
              class="input-new-tag"
              size="small"
              @blur="handleInputConfirm"
              @keyup.enter.native="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" plain size="small" type="success" @click="showInput">+ 添加
          </el-button>
        </div>
        <el-button class="btn confirm" size="middle" type="primary right" @click="closeMask(1)">确定</el-button>
        <el-button class="btn cancel" size="middle" type="warning right" @click="closeMask(2)">取消</el-button>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>

export default {
  name: "backTagManage",
  data() {

    return {
      inputKeyword: '',
      selectSearch: '名称',
      multipleSelection: [],
      valueTimeInterval: '',
      valueEnclosure: '',
      listPageSize: 10,//单页数据数
      listPageTotal: 0,//总数据数量
      listSize: 10,//总页数
      currentPage: 1,//当前页
      tenderingListTitle: [
        {
          name: '编码',
          propertyName: 'code'
        },
        {
          name: '一级标签',
          propertyName: 'level_1'
        },
        {
          name: '二级标签',
          propertyName: 'level_2'
        },
        {
          name: '三级标签',
          propertyName: 'level_3'
        },
        {
          name: '四级标签',
          propertyName: 'level_4'
        },
        {
          name: '五级标签',
          propertyName: 'level_5'
        },
        {
          name: '六级标签',
          propertyName: 'level_6'
        },
        {
          name: '通用词/近义词',
          propertyName: 'generalTerm'
        }
      ],
      tagsList: [],
      maskShow: false,
      optionsAddGeneralTerm: {
        code: '',
        dynamicTags: [],
        inputVisible: false,
        inputValue: ''
      },
      dialogAddVisible: false,
      level_1: [],
      level_2: [],
      level_3: [],
      level_4: [],
      level_5: [],
      level_6: [],
      addTagName: '',
      addTagCodeLength: 1,
      addTagForm: {
        levelSelectShow: 1,
        code: '',
        level_1: '',
        level_2: '',
        level_3: '',
        level_4: '',
        level_5: '',
        level_6: '',
        generalTerm: ['近义词', '同义词']
      }
    }
  },
  computed: {
    firstLevelChange() {
      return this.addTagForm.level_1;
    }
  },
  watch: {
    firstLevelChange() {
    }
  },
  mounted() {
    this.requestTagsList();
  },
  methods: {
    searchTags() {
      this.requestTagsList();
    },
    toggleSelection(rows) {
      // console.log(rows)
      if (rows) {
        rows.forEach(row => {
          // console.log(this.$refs.multipleTable.toggleRowSelection)
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {//表格选中状态切换
      this.multipleSelection = val;
    },
    saveEditItem(row, propertyName) {
      // console.log(row);
      row[propertyName].edit = false;
      this.$request.modifyItemName({
        id: row.id.value,
        name: row[propertyName].value
      }).then(res => {
        if (res.status == 200) {
          this.requestTagsList();
        } else {
          this.requestError(res.status, res.message)
        }
      }, err => {
        console.log(err);
        this.requestFail(err);
      });
    },
    addNewTag() {//点击添加标签
      this.$request.listItemChildren().then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.level_1 = res.data;
          this.dialogAddVisible = true;
        } else {
          this.requestError(res.status, res.message)
        }
      }, err => {
        console.log(err);
        this.requestFail(err);
      });
    },
    closeAddTag() {
      this.dialogAddVisible = false;
    },
    addTagChange(val, level) {
      console.log(val, level);
      let isNewTag = true;
      this['level_' + level].forEach(item => {
        if (val == item.code) {
          isNewTag = false
        }
      });
      if (isNewTag) {
        this.addTagName = val;
        this.addTagCodeLength = 2 * level - 1;
        this.addTagForm.levelSelectShow = level;
      } else {
        this.addTagForm.code = val;
        this.addTagForm.levelSelectShow = level + 1;
        this.$request.listItemChildren({
          code: val
        }).then(res => {
          // console.log(res);
          if (res.status == 200) {
            this['level_' + (level + 1)] = res.data;

            for (let i = level; i < 6; i++) {
              if (this['level_' + (i + 2)] && this['level_' + (i + 2)].length > 0) {
                this['level_' + (i + 2)] = [];
              }
              this.addTagForm['level_' + (i + 1)] = '';
              // console.log(this.addTagForm)
            }
          } else {
            this.requestError(res.status, res.message)
          }
        }, err => {
          console.log(err);
          this.requestFail(err);
        });
      }

    },
    confirmAddTag() {
      if (this.addTagName) {
        if (this.addTagForm.code.length === this.addTagCodeLength) {
          let loading = this.$loading(this.utils.defaultLoadingOptions);
          this.$request.addItem({
            code: this.addTagForm.code,
            name: this.addTagName
          }).then(res => {
            // console.log(res);
            loading.close();
            if (res.status == 200) {
              this.dialogAddVisible = false;
              this.requestTagsList();
              this.$message({
                type: 'success',
                message: '添加成功！'
              })
            } else {
              this.requestError(res.status, res.message)
            }
          }, err => {
            console.log(err);
            this.requestFail(err);
          });
        } else {
          this.$message({
            type: 'warning',
            message: '编码格式不正确！'
          })
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请输入新品目名称！'
        })
      }

    },
    cellEdit(row, column, cell) {
      // console.log(row, column,cell);
      if (cell.innerText !== '-') {
        if (column.property === 'generalTerm') {//修改近义词
          // console.log(row.extendItems.value);
          let dynamicTags = [];
          row.extendItems.value.forEach(item => {
            dynamicTags.push(item.extendName)
          });
          this.optionsAddGeneralTerm.dynamicTags = dynamicTags;
          this.optionsAddGeneralTerm.code = row.code.value;
          this.maskShow = true;
          // console.log(row);
        }
        // if(column.property!=='code'&&column.property!=='generalTerm'){
        if (column.property.charAt(column.property.length - 1) == row.level.value) {
          row[column.property].edit = true;
          setTimeout(() => {
            // console.log(this.$refs,column.property)
            this.$refs[column.property][0].focus();
          }, 20)
        }
      }

    },
    closeMask(type) {
      if (type === 1) {//确认按钮

        this.$request.modifyExtendItems({
          itemCode: this.optionsAddGeneralTerm.code,
          extendItemNames: this.optionsAddGeneralTerm.dynamicTags
        }).then(res => {
          if (res.status == 200) {
            this.maskShow = false;
            this.requestTagsList();
            this.optionsAddGeneralTerm.dynamicTags = [];
          } else {
            this.requestError(res.status, res.message)
          }
        }, err => {
          console.log(err);
          this.requestFail(err);
        });
      } else {//取消按钮
        this.maskShow = false;
        this.optionsAddGeneralTerm.dynamicTags = [];
      }

    },
    handleClose(tag) {//删除已添加的近义词
      this.optionsAddGeneralTerm.dynamicTags.splice(this.optionsAddGeneralTerm.dynamicTags.indexOf(tag), 1);
    },

    showInput() {//显示添加近义词输入框
      this.optionsAddGeneralTerm.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {//确认添加近义词
      let inputValue = this.optionsAddGeneralTerm.inputValue;
      if (inputValue) {
        this.optionsAddGeneralTerm.dynamicTags.push(inputValue);
      }
      this.optionsAddGeneralTerm.inputVisible = false;
      this.optionsAddGeneralTerm.inputValue = '';
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.listPageSize = val;
      this.requestTagsList().then(() => {
        loading.close()
      })
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.currentPage = val;
      this.requestTagsList().then(() => {
        loading.close()
      })
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let loading = this.$loading(this.utils.defaultLoadingOptions);
        this.$request.deleteTenderingMessage({
          id: row.id
        }).then(res => {
          console.log(res)
          loading.close();
          if (res.status == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.requestTenderingMessageList();
          } else {
            this.$message({
              type: 'info',
              message: '删除失败！'
            });
            this.requestError(res.status, res.message)
          }
        }, err => {
          console.log(err);
          loading.close();
          this.requestFail(err);
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    batchDeletion() {//批量删除
      if (this.multipleSelection.length > 0) {
        this.$confirm('此操作将删除选中的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let loading = this.$loading(this.utils.defaultLoadingOptions);
          let data = [];
          this.multipleSelection.forEach(item => {
            data.push(item.id.value)
          })
          this.$request.deleteItems({
            ids: data
          }).then(res => {
            loading.close();
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: '删除成功！'
              });
              this.requestTagsList();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败！'
              });
              this.requestError(res.status, res.message)
            }
          }, err => {
            console.log(err);
            loading.close();
            this.requestFail(err)
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      } else {
        this.$confirm('请至少选中一条数据！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false
        })
      }

    },
    requestTagsList() {
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      let data = {};
      if (this.selectSearch == 2) {
        data.code = this.inputKeyword;
      } else {
        data.name = this.inputKeyword;
      }
      return new Promise((resolve, reject) => {
        this.$request.tagsList({
          ...data,
          pageNum: this.currentPage,
          pageSize: this.listPageSize
        }).then(res => {
          console.log(res);
          resolve(res)
          if (res.status == 200) {
            let tagsList = res.data.list;
            tagsList.forEach(item => {
              let generalTerm = '';
              item.level_1 = '-';
              item.level_2 = '-';
              item.level_3 = '-';
              item.level_4 = '-';
              item.level_5 = '-';
              item.level_6 = '-';
              item['level_' + item.level] = item.name;
              item['generalTerm'] = '无';
              if (item.parents && item.parents.length > 0) {
                item.parents.forEach(item2 => {
                  item['level_' + item2.level] = item2.name
                });
              }

              if (item.extendItems && item.extendItems.length > 0) {
                item.extendItems.forEach(item2 => {
                  generalTerm += item2.extendName + '、';
                });
                item.generalTerm = generalTerm.substring(0, generalTerm.length - 1);
              } else {
                item.extendItems = [];
              }

              for (let key in item) {
                item[key] = {
                  value: item[key],
                  edit: false
                }
              }
            });
            /*tagsList.forEach(item=>{

            })*/
            this.tagsList = tagsList;
            this.listPageTotal = res.data.total;
            loading.close();
          } else {
            this.requestError(res.code, res.message)
          }

        }, err => {
          console.log(err);
          loading.close();
          this.requestFail();
          reject(err);
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
#container {
  .mask-layer {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;

    & > .content {
      width: 600px;
      min-height: 100px;
      .border-radius();
      background-color: #ffffff;
      position: relative;

      .tags-control {
        margin: 20px;

        .el-tag {
          height: 30px;
          line-height: 28px;
          vertical-align: middle;
          margin-left: 10px;
          margin-top: 5px;
        }

        .button-new-tag {
          margin-left: 10px;
          height: 32px;
          line-height: 30px;
          padding-top: 0;
          padding-bottom: 0;
          vertical-align: middle;
          margin-top: 5px;
        }

        .input-new-tag {
          width: 90px;
          margin-left: 10px;
          vertical-align: middle;
          margin-top: 5px;
        }
      }

      .btn {
        margin: 20px 10px;
      }
    }
  }

  .screen-form {
    .screen-form-item {
      margin-bottom: 30px;

      &.screen-form-btn {
        padding: 20px 100px;
      }

      & > .title {
        width: 80px;
        font-weight: bold;
        cursor: default;
        text-align-last: justify;
        font-size: 14px;
        margin-right: 10px;
        padding: 5px 10px;
      }

    }

  }

  .pagination-wrap {
    margin-top: 50px;
  }
}

</style>